import React from "react";

const Surgeries = ({
  formData,
  handleChange,
  handleCheckboxChange,
  dtDisplay,
}) => {
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 복사-붙여넣기 자동 포맷팅 핸들러
  const handlePaste = (e, fieldName) => {
    e.preventDefault(); // 기본 붙여넣기 동작 방지

    const pastedData = e.clipboardData.getData("text");
    const numbers = pastedData.replace(/\D/g, ""); // 숫자만 추출

    if (numbers.length <= 12) {
      // 자동 포맷팅 적용
      let formattedValue = numbers;

      if (numbers.length >= 4) {
        formattedValue = numbers.slice(0, 4) + "-" + numbers.slice(4);
      }
      if (numbers.length >= 6) {
        formattedValue =
          formattedValue.slice(0, 7) + "-" + formattedValue.slice(7);
      }
      if (numbers.length >= 8) {
        formattedValue =
          formattedValue.slice(0, 10) + " " + formattedValue.slice(10);
      }
      if (numbers.length >= 10) {
        formattedValue =
          formattedValue.slice(0, 13) + ":" + formattedValue.slice(13);
      }

      // 포맷된 값으로 필드 업데이트
      handleChange({
        target: { name: fieldName, value: formattedValue },
      });
    }
  };

  // 수술 정보를 렌더링하는 함수
  const renderSurgerySection = (index) => {
    return (
      <>
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Cranial surgery Start date/time (cranial_surg{index}_start_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_start_dt`}
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData[`cranial_surg${index}_start_dt`])}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length <
                    (dtDisplay(formData[`cranial_surg${index}_start_dt`]) || "")
                      .length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: `cranial_surg${index}_start_dt`,
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, `cranial_surg${index}_start_dt`)}
              />
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">
              Cranial surgery End date/time (cranial_surg{index}_end_dt)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_end_dt`}
                placeholder="YYYY-MM-DD HH:MM"
                value={dtDisplay(formData[`cranial_surg${index}_end_dt`])}
                onChange={(e) => {
                  const input = e.target.value;

                  // 현재 입력된 값에서 이전 값보다 짧아졌다면 백스페이스로 간주
                  if (
                    input.length <
                    (dtDisplay(formData[`cranial_surg${index}_end_dt`]) || "")
                      .length
                  ) {
                    handleChange(e);
                    return;
                  }

                  // 숫자만 추출
                  const numbers = input.replace(/\D/g, "");

                  if (numbers.length <= 12) {
                    // 최대 12자리 (YYYYMMDDHHmm)
                    let formattedValue = numbers;

                    // 날짜 시간 포맷팅
                    if (numbers.length >= 4) {
                      formattedValue =
                        numbers.slice(0, 4) + "-" + numbers.slice(4);
                    }
                    if (numbers.length >= 6) {
                      formattedValue =
                        formattedValue.slice(0, 7) +
                        "-" +
                        formattedValue.slice(7);
                    }
                    if (numbers.length >= 8) {
                      formattedValue =
                        formattedValue.slice(0, 10) +
                        " " +
                        formattedValue.slice(10);
                    }
                    if (numbers.length >= 10) {
                      formattedValue =
                        formattedValue.slice(0, 13) +
                        ":" +
                        formattedValue.slice(13);
                    }

                    // 원래의 handleChange 함수 호출
                    handleChange({
                      target: {
                        name: `cranial_surg${index}_end_dt`,
                        value: formattedValue,
                      },
                    });
                  }
                }}
                onPaste={(e) => handlePaste(e, `cranial_surg${index}_end_dt`)}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Cranial surgery types (cranial_surg{index}_types)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Decompressive Craniectomy",
                  "Craniotomy",
                  "Burr-hole trephination",
                  "Minimally invasive surgery (cath)",
                  "Minimally invasive surgery (endoscopic)",
                  "External ventricular drainage",
                  "Intraventricular rt-PA",
                  "Intrahematomal rt-PA",
                  "Bypass",
                  "Clipping",
                  "Trapping alone",
                  "Wrapping",
                  "Hunterian ligation alone",
                  "Coil",
                  "Coil with balloon remodeling",
                  "Stent only",
                  "Stent/coil",
                  "Vessel occlusion",
                  "Flow diverter",
                  "Lobectomy",
                  "Evacuate SDH",
                  "Evacuate EDH",
                  "Evacuate ICH",
                  "Abscess drainage",
                  "VP shunt programmable",
                  "VP shunt Non-programmable",
                  "Shunt revision",
                  "Cranioplasty",
                  "Brain debridement",
                  "Others, specify",
                ].map((option) => (
                  <label key={option} className="checkbox-label">
                    <input
                      type="checkbox"
                      name={`cranial_surg${index}_types`}
                      value={option}
                      checked={(
                        formData[`cranial_surg${index}_types`] || []
                      ).includes(option)}
                      onChange={handleCheckboxChange}
                    />
                    <span className="checkbox-text">{option}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Cranial surgery types others (cranial_surg{index}_types_others)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_types_others`}
                value={formData[`cranial_surg${index}_types_others`] || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Surgery reason (cranial_surg{index}_reason)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "Emergency/Life saving",
                  "Clinical deterioration",
                  "Mass effect on CT",
                  "Radiological progression",
                  "Suspicion of raised ICP",
                  "Guideline adherence",
                  "To prevent deterioration",
                  "Others, specify",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name={`cranial_surg${index}_reason`}
                      value={option}
                      checked={
                        formData[`cranial_surg${index}_reason`] === option
                      }
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Surgery reason others (cranial_surg{index}_reason_others)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_reason_others`}
                value={formData[`cranial_surg${index}_reason_others`] || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Surgery delay (cranial_surg{index}_delay)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  "No delay",
                  "Transferral from other hospital",
                  "Haemodynamic instability",
                  "No OR available",
                  "surgeon delayed",
                  "Consent delayed",
                  "Other",
                ].map((option) => (
                  <label key={option} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name={`cranial_surg${index}_delay`}
                      value={option}
                      checked={
                        formData[`cranial_surg${index}_delay`] === option
                      }
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="block-2column">
            <label className="item_title_2col">
              Surgery delay others (cranial_surg{index}_delay_others)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_delay_others`}
                value={formData[`cranial_surg${index}_delay_others`] || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Notes or additional information about surgeries (cranial_surg
              {index}_notes)
            </label>
            <div className="input_2col">
              <input
                type="text"
                name={`cranial_surg${index}_notes`}
                value={formData[`cranial_surg${index}_notes`] || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <section className="vip-form-section">
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">Surgeries</h3>

        {/* Cranial surgery 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              금번 입원 기간 (일반병실 포함) 중 cranial surgery 여부
              (cranial_surg_done)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="cranial_surg_done"
                      value={option.value}
                      checked={formData.cranial_surg_done === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Extracranial surgery 여부 */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              금번 입원 기간 (일반병실 포함) 중 extracranial surgery 여부
              (extracranial_surg_done)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "No", value: "No" },
                  { label: "Yes", value: "Yes" },
                  { label: "Unknown", value: "Unknown" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="extracranial_surg_done"
                      value={option.value}
                      checked={formData.extracranial_surg_done === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <h3 className="section-subtitle">Common</h3>

        {/* 수술 정보 섹션들 */}
        <h4 className="section-subtitle">Surgery 1</h4>
        {renderSurgerySection(1)}

        <h4 className="section-subtitle">Surgery 2</h4>
        {renderSurgerySection(2)}

        <h4 className="section-subtitle">Surgery 3</h4>
        {renderSurgerySection(3)}

        <h4 className="section-subtitle">Surgery 4</h4>
        {renderSurgerySection(4)}

        <h4 className="section-subtitle">Surgery 5</h4>
        {renderSurgerySection(5)}

        {/* Completion status */}
        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Completion status_7 (surgeries_status)
            </label>
            <div className="input_2col">
              <div className="rad-group vertical">
                {[
                  { label: "Not started", value: "Not started" },
                  { label: "In process", value: "In process" },
                  { label: "Complete", value: "Complete" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="surgeries_status"
                      value={option.value}
                      checked={formData.surgeries_status === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Surgeries;
